<ion-header>
  <ion-toolbar class="top-toolbar">
    <ion-buttons slot="start">
      <ion-button (click)="closemodal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ 'Title-about' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col size-sm="8" offset-sm="2" size="10" offset="1" class="ion-text-center margin">
         <img src="../../assets/icon/new_wn_logo_text_transparent_background.png" alt="Waiternow logo">  
         <ion-label (click)="onExtLinkClick('Main')"> <h1>waiternow.com</h1> </ion-label> 
      </ion-col>
    </ion-row>
    <ion-row style="padding: 5%;">
    </ion-row>
    <ion-row>
      <ion-col class="ion-text-center">
          <ion-text> {{ 'Help-content2' | translate }}</ion-text>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size-sm="6" offset-sm="3" size="10" offset="1" class="ion-text-center">
        <ion-label class="title" (click)="copyMessage('info@waiternow.com')"> <h1>{{'info@waiternow.com'}}</h1> </ion-label>
      </ion-col>
    </ion-row>
    <ion-row >
      <ion-col>
        <input hidden="true" type="text" value="info@waiternow.com" #emaillabel>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer>
  <ion-toolbar class="toolbar">
    <ion-button size="small" fill="none" expand="full" (click)="onExtLinkClick('Terms')">{{ 'Title-tos' | translate }}</ion-button>
    <ion-button size="small" fill="none" expand="full" (click)="onExtLinkClick('Cookies')">{{ 'Title-cookie' | translate }}</ion-button>
    <ion-button size="small" fill="none" expand="full" (click)="onExtLinkClick('Privacy')">{{ 'Title-privacy' | translate }}</ion-button>
    <ion-item size="small" class="ion-text-center" lines="none">
      <ion-label>Version GIT NEW: {{ buildVersion }}</ion-label>
    </ion-item>
  </ion-toolbar>
</ion-footer>
